<form class="form" [formGroup]="dontSeeYourWorkplaceFormGroup">

  <div class="row no-gutters" *ngIf="showEnterWorkplaceFormManuallySection">
    <div class="col-12 dontseeyour-workplace">
      <p [innerHTML]="cfetLabels.cfet_customer_eligibility.utf_dont_see_your_workplace_desc"></p>
    </div>
  </div>

  <div class="row no-gutters">
    <div class="col-12 form-row" id="name-input" [class.error]="!isValidName">
      <label for="name">{{cfetLabels.cfet_customer_eligibility.utf_org_name}}</label>
      <div class="name-inputbox">
        <input id="name" class="name" name="name" tabindex="0" formControlName="nameValue" maxlength="256" type="text"
          restrict-input="restrictforOrgName" autocomplete="off" aria-label="Organization name"  (keyup.enter)="searchOrgName($event)" 
          (blur)="checkName()">
       <button class="btn-search" type="button" (mousedown)="searchOrgName($event)" >
            <em class="icon-magnifyingglass"></em></button> 
        <div *ngIf="!isValidName" role="alert" [attr.aria-atomic]="true" [ngClass]="{'error-msg' : (!isValidName)}">
          <em class="icon-badgealert" aria-hidden="true"></em>
          <span *ngIf="!isValidName">{{cfetMessages.Org_name_error}}</span>
        </div>
      </div>
    </div>

    <div class="row public-safety-entity-type" *ngIf="suggestions && suggestions.length > 0">
        <div class="suggestion-header"> <img src="assets/images/aiStar.png" alt="Star"><span>AI Suggestions</span></div>
                
        <div class="suggestions-container">
          <div  class="suggestion-box" 
              *ngFor="let suggestion of suggestions" 
              (click)="onSuggestionClick(suggestion)"
              tabindex="0"
              role="button"
              aria-pressed="false">
                {{ suggestion }}
          </div>
        </div>
    </div>


    <div class="col-lg-6 col-12 form-row" id="address1-input" [class.error]="isValidAddress1">
      <label for="address1">{{cfetLabels.cfet_customer_eligibility.addressline1}}</label>
      <div class="address1-inputbox">
        <input id="address1" class="address1" name="address1" tabindex="0" formControlName="address1Value"
          maxlength="256" (keydown)="keyDownHandler($event)" (paste)="pasteHandler($event)"
          type="text" autocomplete="off" aria-label="Address line 1" (blur)="checkAddress1()" (keyup)="autoPopulateAPI()">
        <div id="search-result" *ngIf="displaySearchResult || noResultFound">
            <div id="workplace-link" *ngIf="noResultFound">
              <p id="manually-enter">{{cfetLabels.cfet_customer_information.no_results_found}}</p>
            </div>
          <ul id="address-field-list" role="menu" *ngIf="displaySearchResult">
            <li id="address-field-details" *ngFor="let row of addressList;let i= index;"
                (click)="onChangeaddress($event, row)" (keyup)="onChangeaddress($event, row)"
                tabindex="0">
              <p><span>{{row.street_line}},</span>
                <span *ngIf="row.secondary">{{row.secondary}},</span>
                <span>{{row.city}},{{row.state}} {{row.zipcode}}</span>
                <span *ngIf="row.entries !== 0"> ({{row.entries}})</span>
              </p>
            </li>
          </ul>
        </div>
        <div *ngIf="isValidAddress1" role="alert" [attr.aria-atomic]="true" [ngClass]="{'error-msg' : isValidAddress1}">
          <em class="icon-badgealert" aria-hidden="true"></em>
          <span *ngIf="isValidAddress1">{{cfetMessages.address_line}}</span>
        </div>
      </div>
    </div>
    <div class="col-lg-6 col-12 form-row" id="address2-input">
      <label for="address2" id="address2-label">{{cfetLabels.cfet_customer_eligibility.addressline2}}
      </label>
      <div class="address2-inputbox">
        <input id="address2" class="address2" name="address2" tabindex="0" formControlName="address2Value"
          maxlength="256" (keydown)="keyDownHandler($event)" 
          (paste)="pasteHandler($event)" type="text" autocomplete="off" aria-label="Address line 2"
          placeholder="Building, suite, floor, (optional)">
      </div>
    </div>
    <div class="col-lg-4 col-12 form-row" id="city-input" [class.error]="cityError">
      <label for="city">{{cfetLabels.cfet_customer_eligibility.city}}</label>
      <div class="city-inputbox">
        <input id="city" class="city" name="city" tabindex="0" formControlName="cityValue" maxlength="40"
        (keydown)="keyDownHandler($event)" (paste)="pasteHandler($event)" type="text"
          restrict-input="restrictforModalCity" aria-label="City" (blur)="checkCity()">
        <div *ngIf="cityError" role="alert" [attr.aria-atomic]="true" [ngClass]="{'error-msg' : (cityError)}">
          <em class="icon-badgealert" aria-hidden="true"></em>
          <span *ngIf="cityError">{{cfetMessages.city}}</span>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-6 form-row" id="row-dropdown">
      <label for="select_state">{{cfetLabels.cfet_customer_eligibility.state}}</label>
      <div class="field-group">
        <div [ngClass]="checkState ? 'dropdown-opened' : ''">
          <abs-dropdown [drId]="'select_state'" [drName]="'stateValue'" [(dropdownValue)]="stateValueOption"
            formControlName="stateValue" [optionRepeat]="stateList" (dropdownValueChange)="onChangeState($event)"
            (click)="onClickState($event)" (blur)="checkStateFn()" ngDefaultControl>
          </abs-dropdown>
        </div>
        <div *ngIf="stateError" role="alert" [attr.aria-atomic]="true"
            [ngClass]="{'error-msg' : (stateError)}">
            <em class="icon-badgealert" aria-hidden="true"></em>
            <span *ngIf="stateError">{{cfetMessages.state}}</span>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-6 form-row" id="zipcode-input" [class.error]="zipcodeError">
      <label for="zipcode">{{cfetLabels.cfet_customer_eligibility.zipcode_manually}}</label>
      <div class="zipcode-inputbox">
        <input id="zipcode" class="zipcode" name="zipcode" tabindex="0" formControlName="zipCode" maxlength="5"
          type="text" restrict-input="restrictUTFzipcode" aria-label="Zipcode" (input)="changeZip()" (blur)="checkZip()">
        <div *ngIf="zipcodeError" role="alert" [attr.aria-atomic]="true" [ngClass]="{'error-msg' : (zipcodeError)}">
          <em class="icon-badgealert" aria-hidden="true"></em>
          <span *ngIf="zipcodeError">{{cfetMessages.valid_zipcode}}</span>
        </div>
      </div>
    </div>
  </div>

  <hr />

  <div class="row no-gutters">
    <div class="col-12 btn-container">
      <a data-dismiss="modal" (click)="cancelCreation($event)" (keyup)="cancelCreation($event)" tabindex="0"
        type="button" id="cancel_link">
        {{cfetButtonLabels.button_labels.cancel}}</a>
      <button tabindex="0" type="button" id="back-btn" class="btn" (click)="editWorkplace($event)"
        (keyup)="editWorkplace($event)">
        {{cfetButtonLabels.button_labels.back}}</button>
      <button type="button" id="btn-submit" (click)="submit($event)" (keyup)="submit($event)" class="btn" tabindex="0"
        [disabled]="disabledSubmitButton">
        {{cfetButtonLabels.button_labels.continue}}</button>
    </div>
  </div>


  <div class="row no-gutters" id="eligibility-completion-section" *ngIf="showEligibilityCompletion">
    <div class="col-10 eligibility-mobile-max">
      <div class="selected-workplace">
        <label for="selected-name" class="selected-workplace-address">{{selectedName}}</label><br>
        <label for="selected-workplace-city-state-zipcode"
          class="selected-workplace-city-state-zipcode">{{this.selectedAddress1}}, {{selectedCity}},
          {{selectedState}} {{selectedZip}}</label>
      </div>
    </div>
    <div class="col-12" id="eligibility-completion">
      <app-customer-eligibility-utf-completion></app-customer-eligibility-utf-completion>
    </div>
  </div>

</form>